import * as PIXI from 'pixi.js';
import AssetsLoader from '../utils/assetsLoader';
import CardContainer from './cardContainer';
import { RESOLUTION } from '../utils/commonUtils';
import { getGlobalEventEmitter } from '../utils/globalEventEmitter';


export default class TrashContainer extends PIXI.Container {
    constructor(isPlayer) {
        super();

        const trashFrameTexture = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.TRASH_FRAME);
        const trashFrame = new PIXI.Sprite(trashFrameTexture);
        trashFrame.anchor.set(0.5, 1);
        trashFrame.x = 0;
        trashFrame.y = 0;
        this.addChild(trashFrame);

        this.eventMode = 'static';
        this.on('pointerdown', (event) => {
            event.stopPropagation();
            getGlobalEventEmitter()?.emit('trashClicked', isPlayer);
        });
    }

    update(playerState) {
        this.getChildByLabel('trashCard')?.destroy({children: true});
        const topTrashCardInstance = playerState.trash[playerState.trash.length-1];

        if (topTrashCardInstance) {
            const trashCard = new CardContainer(topTrashCardInstance);
            trashCard.label = 'trashCard';
            trashCard.x = -54*RESOLUTION;
            trashCard.y = -64*RESOLUTION;
            trashCard.angle = 90;
            trashCard.scale.set(0.4);
            trashCard.showRested = false;
            trashCard.hidePowerText();
            trashCard.hideCost();
            trashCard.eventMode = 'none';

            this.addChild(trashCard);
        }
    }
}
